<template>
  <table class="SingleColumnTable">
    <tbody>
      <tr v-for="row in table.rows" :style="row.style">
        <th @click="toggleShowingPopover(row)" style="white-space: nowrap;">
          <slot name="header" :row="row">
            {{ row.rowName }}
          </slot>
        </th>
        <component v-bind="row.cells[0].componentArgs" :style="row.cells[0].style"
          :key="row.id"
          :is="row.cells[0].componentType"
          :row="row"
          :cell="row.cells[0]"
          :columnTag="row.cells[0].columnTag"
          :selectedCells="row.cells"
          :showingPopover="isShowingPopover(row)"
          @update:showingPopover="value => setShowingPopover(row, value)"
        ></component>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { computed } from "vue";
import { createSingleColumnTableData, resolveTable } from "./TableUtility.js";

let props = defineProps([
  "session",
  "tableKey",
  "tableData",
  "column",
  "selectedRowId"
]);

let selectedRowId = defineModel("selectedRowId");

let table = computed(() => {
  let singleColumnData = null;
  let session = props.session;
  if (props.tableData) {
    singleColumnData = props.tableData;
  }
  else {
    let multiColumnData = session.system.tables[props.tableKey].value;
    singleColumnData = createSingleColumnTableData(multiColumnData, props.column);
  }
  let table = resolveTable(session, session.system, singleColumnData);
  return table;
});

function isShowingPopover(row) {
  return row.id == selectedRowId.value;
}

function toggleShowingPopover(row) {
  let newValue = !isShowingPopover(row);
  setShowingPopover(row, newValue);
}

function setShowingPopover(row, value) {
  if (value)
    selectedRowId.value = row.id;
  else if (row.id == selectedRowId.value)
    selectedRowId.value = null;
}

</script>

<style scoped>
.SingleColumnTable {
  max-width: 550px;
  border-collapse: collapse;
}
th {
  padding: 10px;
  padding-left: 0;
  text-align: left;
}
:deep(td) {
  padding: 10px;
  padding-right: 0;
  text-align: right;
}
:deep(td) .flex .right {
  display: none;
}
</style>